require('./modal.scss');

//
// NOTE:
// In order to close the modal the using component controller needs
// to access the scope function `$hide()` (or improve the code to be
// able to give a onClose callback as binding).
//
const ModalComponent = {
    selector: 'sbModal',
    template: require('./modal.html'),
    bindings: {
        title: '@',
    },
    transclude: {
        header: '?sbModalHeader',
        content: '?sbModalContent',
        actions: '?sbModalActions',
    },
};

export default ModalComponent;



// WEBPACK FOOTER //
// ./src/app/components/modal/index.js